module.exports = __webpack_public_path__ + "static/media/6-_DSC6893.d6a33dc7.jpg";